import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import showApproveReject from '../../Lib/Utils/VendorApplication/show-approve-reject';
import ApproveReject from '../ApproveReject/ApproveReject';
import ApprovalSignatures from '../ApprovalSignatures/ApprovalSignatures';
import VendorMerchType from './VendorMerchType';

const useStyles = makeStyles()(() => ({
  fields: {
    borderRadius: '12px',
    boxShadow: '-11px 9px 21px 0 rgba(173, 182, 217, 0.17)',
    marginTop: '40px',
    paddingLeft: '30px',
  },
  header: {
    color: 'black',
    fontSize: '26px',
    fontWeight: 'bold',
    lineHeight: '32px',
    textTransform: 'uppercase',
  },
}));

export default function ComplianceSection(props) {
  const { classes } = useStyles();
  const [disableApprove, setDisableApprove] = useState(true);

  useEffect(() => {
    const merchType = props.vendor.merch_type;
    if (merchType && merchType !== '') {
      setDisableApprove(false);
    }
  }, [props.vendor.merch_type]);

  return (
    <Grid>
      <h4 className={classes.header}>Vendor Compliance</h4>
      <div className={classes.fields}>
        {showApproveReject(props.vendor, props.currentUser) && (
          <ApproveReject
            onReject={props.onReject}
            record={props.user}
            title="Vendor"
            onApprove={props.onApprove}
            disableApprove={disableApprove}
          />
        )}

        <VendorMerchType
          value={props.vendor.merch_type}
          onChange={props.onChange}
          disabled={!props.perms.canUpdate}
        />

        <ApprovalSignatures
          onChange={props.onChange}
          onChangeFile={props.onChangeFile}
          form={props.form}
          fileLinks={props.fileLinks}
          vendor={props.vendor}
          perms={props.perms}
        />
      </div>
    </Grid>
  );
}

ComplianceSection.propTypes = {
  currentUser: PropTypes.shape({}).isRequired,
  form: PropTypes.shape({}).isRequired,
  fileLinks: PropTypes.shape({}).isRequired,
  onApprove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeFile: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  user: PropTypes.shape({}).isRequired,
  vendor: PropTypes.shape({
    submitted_at: PropTypes.string,
    is_direct: PropTypes.bool,
    merch_type: PropTypes.string,
  }).isRequired,
  perms: PropTypes.shape({
    canUpdate: PropTypes.bool,
    canDelete: PropTypes.bool,
    canRead: PropTypes.bool,
    canCreate: PropTypes.bool,
  }).isRequired,
};
